import { apiClient } from "./authService";

export interface StockPoolMember {
  id: string;
  name: string;
  isAnchor?: boolean;
}

export interface StockPool {
  id: string;
  name: string | null;
  anchorBusinessId?: string;
  anchor_business_id?: string;
  members: StockPoolMember[];
}

export const getStockPools = async (): Promise<StockPool[]> => {
  const res = await apiClient.get<StockPool[]>("/business/stock-pools");
  return res.data;
};

export const updateStockPoolTarget = async (
  businessId: string,
  targetBusinessId: string | null
): Promise<any> => {
  const res = await apiClient.patch(`/business/${businessId}/stock-pool`, {
    targetBusinessId,
  });
  return res.data;
};
